import React from 'react';
import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives/compiled';

const ApplinksHeader = () => {
	return (
		<>
			<Stack space="space.200">
				<Heading size="large">Application Links</Heading>
				<Text>
					Application links let you integrate Jira with another Atlassian product or external
					application so they can exchange information, resources, and functionalities. What exactly
					is exchanged will depend on the applications you link. Learn more about application links
				</Text>
			</Stack>
		</>
	);
};

export default ApplinksHeader;
